import Model from '@/models/Model'

export default class AReject extends Model {
    resource() {
        return 'reject'
    }
}
